var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherArchive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9344 5.32333L13.8433 3.23223C13.3745 2.76339 12.7386 2.5 12.0756 2.5H5.83334C4.45263 2.5 3.33334 3.61929 3.33334 5V15C3.33334 16.3807 4.45263 17.5 5.83334 17.5H14.1667C15.5474 17.5 16.6667 16.3807 16.6667 15V7.09109C16.6667 6.42805 16.4033 5.79217 15.9344 5.32333V5.32333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6667V8.75C10 8.05964 10.5596 7.5 11.25 7.5V7.5C11.9404 7.5 12.5 8.05964 12.5 8.75V11.6667C12.5 13.0474 11.3807 14.1667 10 14.1667V14.1667C8.61929 14.1667 7.5 13.0474 7.5 11.6667V9.16667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherArchive);
export default ForwardRef;